import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgBrightMoments = (props, ref) => (_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M1 23C13.1503 23 23 13.1503 23 1C10.8497 1 1 10.8497 1 23ZM16.5562 16.5562H7.44379V7.44378H16.5562V16.5562Z", fill: "currentColor" }) }));
const ForwardRef = forwardRef(SvgBrightMoments);
export default ForwardRef;
